import { Theme } from "../config/theme.js";

export async function resolveGravityAndRefill(board) {
  const { scene, rows, cols } = board;

  for (let c = 0; c < cols; c++) {
    let writeRow = rows - 1;

    for (let r = rows - 1; r >= 0; r--) {
      const t = board.grid[r][c];
      if (t) {
        if (writeRow !== r) {
          board.grid[writeRow][c] = t;
          board.grid[r][c] = null;
          t.r = writeRow;
          t.c = c;
          t.sprite.__tileData = { r: writeRow, c };
        }
        writeRow--;
      }
    }
    for (let r = writeRow; r >= 0; r--) board.grid[r][c] = null;
  }

  const sprites = [];
  const targets = [];
  for (let r = 0; r < rows; r++) {
    for (let c = 0; c < cols; c++) {
      const t = board.grid[r][c];
      if (!t) continue;
      const pos = board.worldPos(r, c);
      if (Math.abs(t.sprite.x - pos.x) > 0.5 || Math.abs(t.sprite.y - pos.y) > 0.5) {
        sprites.push(t.sprite);
        targets.push(pos);
      }
    }
  }
  await tweenMany(scene, sprites, targets, Theme.anim.fallDuration);

  const spawned = [];
  const spawnedTargets = [];
  for (let c = 0; c < cols; c++) {
    // Collect empty rows top-to-bottom so tiles spawn stacked in order above the board
    const emptyRows = [];
    for (let r = 0; r < rows; r++) {
      if (board.grid[r][c] === null) emptyRows.push(r);
    }
    const total = emptyRows.length;
    for (let i = 0; i < total; i++) {
      const r = emptyRows[i];
      const tile = board.spawnTile(r, c, true);
      const target = board.worldPos(r, c);
      // Row 0 (topmost destination) starts furthest above; last row starts just above board edge.
      // This keeps tiles stacked in order so they never visually cross each other.
      // Garantir que todos os tiles começam fora do ecrã (acima de y=0),
      // evitando que apareçam na área do HUD antes de caírem para o tabuleiro.
      const lastTileSpawnY = Math.min(board.y - board.tileSize, -board.tileSize);
      tile.sprite.y = lastTileSpawnY - (total - 1 - i) * board.tileSize;
      tile.sprite.x = target.x;
      spawned.push(tile.sprite);
      spawnedTargets.push(target);
    }
  }
  await tweenMany(scene, spawned, spawnedTargets, Theme.anim.spawnDuration);
}

function tweenMany(scene, sprites, targets, duration) {
  return new Promise((resolve) => {
    if (!sprites || sprites.length === 0) return resolve();

    let done = 0;
    const total = sprites.length;

    for (let i = 0; i < sprites.length; i++) {
      scene.tweens.add({
        targets: sprites[i],
        x: targets[i].x,
        y: targets[i].y,
        duration,
        ease: "Sine.InOut",
        onComplete: () => {
          done++;
          if (done >= total) resolve();
        }
      });
    }
  });
}
